// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Fault } from "./fault";

export class NormalFault implements flatbuffers.IUnpackableObject<NormalFaultT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): NormalFault {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsNormalFault(bb: flatbuffers.ByteBuffer, obj?: NormalFault): NormalFault {
    return (obj || new NormalFault()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsNormalFault(
    bb: flatbuffers.ByteBuffer,
    obj?: NormalFault,
  ): NormalFault {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new NormalFault()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  message(): Fault {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : Fault.LowerPitSwitch;
  }

  static startNormalFault(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addMessage(builder: flatbuffers.Builder, message: Fault) {
    builder.addFieldInt16(0, message, Fault.LowerPitSwitch);
  }

  static endNormalFault(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createNormalFault(builder: flatbuffers.Builder, message: Fault): flatbuffers.Offset {
    NormalFault.startNormalFault(builder);
    NormalFault.addMessage(builder, message);
    return NormalFault.endNormalFault(builder);
  }

  unpack(): NormalFaultT {
    return new NormalFaultT(this.message());
  }

  unpackTo(_o: NormalFaultT): void {
    _o.message = this.message();
  }

  unpackFields(...fields: string[]): NormalFaultT {
    const t = new NormalFaultT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("message")) {
      t.message = this.message();
    }
    return t;
  }
}

export class NormalFaultT implements flatbuffers.IGeneratedObject {
  constructor(public message: Fault = Fault.LowerPitSwitch) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return NormalFault.createNormalFault(builder, this.message);
  }

  clone(): NormalFaultT {
    const obj = new NormalFaultT();
    obj.message = this.message;
    return obj;
  }

  equals(other: NormalFaultT): boolean {
    if (this.message !== other.message) return false;
    return true;
  }
}

export function verifyNormalFault(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
  } finally {
    verifier.popDepth();
  }
}
